<template>
  <p class="text-center text-4xl font-semibold">{{ t('message') }}</p>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<i18n lang="json">
{
  "en": {
    "message": "Enjoy the ride!"
  },
  "de": {
    "message": "Genießen Sie die Fahrt!"
  },
  "es": {
    "message": "¡Disfrute del viaje!"
  }
}
</i18n>
